"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _react2 = require("@emotion/react");
var _Spin = _interopRequireDefault(require("./Spin"));
var _templateObject, _templateObject2;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const defaultProps = {
  defaultValue: false,
  disabled: false,
  controlled: false,
  loading: false,
  onClick(_) {}
};
function Toggle(props) {
  const {
    defaultValue,
    disabled,
    onClick,
    controlled,
    loading
  } = _objectSpread(_objectSpread({}, defaultProps), props);
  const [active, setActive] = (0, _react.useState)(defaultValue);
  const {
    colors
  } = (0, _react2.useTheme)();
  const value = (0, _react.useMemo)(() => controlled ? defaultValue : active, [active, defaultValue, controlled]);
  const onChange = () => {
    if (disabled) return;
    setActive(!value);
    onClick === null || onClick === void 0 || onClick(!value);
  };
  if (loading) return /*#__PURE__*/_react.default.createElement(_Spin.default, {
    color: colors.MAIN.PRIMARY,
    size: 20
  });
  return /*#__PURE__*/_react.default.createElement(Container, {
    onClick: onChange,
    active: value,
    disabled: disabled
  }, /*#__PURE__*/_react.default.createElement(Circle, null));
}
const Container = _styled.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  & {\n    height: 20px;\n    width: 40px;\n    border-radius: 20px;\n    align-content: center;\n    display: flex;\n    cursor: pointer;\n    opacity: ", ";\n    padding: 0 5px;\n\n    ", "\n  }\n"])), _ref => {
  let {
    disabled
  } = _ref;
  return disabled ? 0.65 : 1;
}, _ref2 => {
  let {
    theme,
    active
  } = _ref2;
  return active ? "\n      justify-content: flex-end;\n      background-color: ".concat(theme.colors.MAIN.PRIMARY, ";\n    ") : "\n      justify-content: flex-start;\n      background-color: ".concat(theme.colors.FONT.DESCRIPTION, ";\n    ");
});
const Circle = _styled.default.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  width: 12px;\n  height: 12px;\n  background-color: white;\n  border-radius: 12px;\n  align-self: center;\n"])));
var _default = exports.default = Toggle;